/* eslint-disable react/jsx-no-undef */
import { Field as FinalFormField } from 'react-final-form';
import { Slider } from 'react-rainbow-components';
import { FieldsContainer, StyledTextarea } from './styled';

const Field = (props: any) => <FinalFormField parse={(value) => value} {...props} />;

const Fields = () => (
    <FieldsContainer>
        <Field
            component={StyledTextarea}
            name="content"
            label="Content"
            labelAlignment="left"
            placeholder="Enter a memory content"
            borderRadius="semi-rounded"
            rows={10}
        />
        <Field
            name="importance"
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            component={Slider}
            label="Importance"
            labelAlignment="left"
            type="number"
            min={1}
            max={10}
            step={1}
        />
    </FieldsContainer>
);

export default Fields;
